import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  validatedate_min_max,
  getlocalstoragedate,
  setlocalstoragedate,
  setKeyboardShortcuts,
  csvFileName,
} from "../SystemUtility/SystemUtility";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import ReceiptEntry from "./ReceiptEntry";
import PaymentMode from "./PaymentMode";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { apiTransportURL, apiURL, fetchtripReciept } from "./API";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import ResetDate from "../images/resetdate.png";
import TripReceiptEntry from "./TripReceiptEntry";
import MaterialTable from "./CustomTool/MaterialTable";
import CtART from "./CustomTool/ResponsiveTable";

class ReceiptList extends Component {
  state = {
    PaymentMode: [],
    LedgerGroup: [],
    Ledger: [],
    columnsdata: [
      {
        accessorKey: "bint_tripincomesrno",
        header: "Receipt No.",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dat_dateDMY",
        header: "Date",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dat_date",
        header: "Date",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_groupname",
        header: "Legder Group",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_ledgername",
        header: "Legder",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_amount",
        header: "Amount",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        muiTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => Math.round(cell.getValue()),
      },
      {
        accessorKey: "vac_remark",
        header: "Remark",
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        Cell: ({ cell }) => (
          <div dangerouslySetInnerHTML={{ __html: cell.getValue() }} />
        ),
      },
      {
        accessorKey: "bint_acid",
        header: "bint_acid",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
    ],
    keyColumn: [
      "bint_tripincomesrno", //0
      "dat_date", //1
      "vac_groupname", //2
      "vac_ledgername", //3
      "dec_amount", //4
      "vac_remark", //5
      "bint_acid", //6
    ],
    rows: [],
    // actionList: [
    //   {
    //     name: "Edit",
    //     icon: <Edit />,
    //     link: "ReceiptList:",
    //     actionType: "AlertResponsive",
    //   },
    //   {
    //     name: "Delete",
    //     icon: <Delete />,
    //     link: "ReceiptList:",
    //     actionType: "AlertResponsive",
    //     hide:
    //       this.props.userPrivilege.Receipt == "R" ||
    //       this.props.userPrivilege.Receipt == "W",
    //   },
    //   {
    //     name: "Print Receipt",
    //     icon: <Print />,
    //     link: "ReceiptList:",
    //     actionType: "AlertResponsive",
    //     hide: this.props.userPrivilege.Receipt == "R",
    //   },
    // ],
    formData: {
      bint_srno: "",
      cmbCompany: "",
      dtpFromDate: "",
      dtpToDate: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,

    searchData: {
      bint_tripincomesrno: "",
      dat_date: "",
      vac_groupname: "",
      vac_ledgername: "",
      dec_amount: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Trip Receipt List";
    this.props.setActiveMenu("ReceiptList");
    this.setSearchColumns();
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.bint_tripincomesrno.length === 0 ||
            (row["bint_tripincomesrno"] &&
              row["bint_tripincomesrno"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.bint_tripincomesrno.toLowerCase()
                ))) &&
          (this.state.searchData.dat_date.length === 0 ||
            (row["dat_date"] &&
              row["dat_date"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dat_date.toLowerCase()))) &&
          (this.state.searchData.vac_groupname === 0 ||
            (row["vac_groupname"] &&
              row["vac_groupname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_groupname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_ledgername === 0 ||
            (row["vac_ledgername"] &&
              row["vac_ledgername"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_ledgername.toLowerCase()
                ))) &&
          (this.state.searchData.dec_amount.length === 0 ||
            (row["dec_amount"] &&
              row["dec_amount"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_amount.toLowerCase()))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };
  handleARDonActionClick_Edit = (row) => {
    let bint_tripincomesrno = row.getValue("bint_tripincomesrno"),
      EditReceiptData = [];
    let ARD = null;
    EditReceiptData = [
      {
        // edit_incomesrno:values[0].value,
        bint_tripincomesrno: row.getValue("bint_tripincomesrno"),
        dat_date: row.getValue("dat_date"),
        vac_groupname: row.getValue("vac_groupname"),
        vac_ledgername: row.getValue("vac_ledgername"),
        dec_amount: row.getValue("dec_amount"),
        vac_remark: row.getValue("vac_remark"),
      },
    ];
    // console.log("EditReceiptData", EditReceiptData);
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // fullscreenOnly={true}
          maxWidthClass={"xl"}
          // Edit : Sales Item Entry
          alertMessage={
            <TripReceiptEntry
              refreshTripReceiptList={this.refreshTripReceiptList}
              bint_tripincomesrno={bint_tripincomesrno}
              EditReceiptData={EditReceiptData}
              dtpFromDate={this.state.formData.dtpFromDate}
              dtpToDate={this.state.formData.dtpToDate}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Delete = (row) => {
    let bint_acid = row.getValue("bint_acid"),
      bint_acyear = localStorage.getItem("ACY"),
      bint_tripincomesrno = row.getValue("bint_tripincomesrno"),
      EditReceiptData = [];
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Delete"
          labelDisagree="Cancel"
          alertTitle={
            "Do you want to Delete Receipt No. : " + bint_tripincomesrno + " ?"
          }
          alertMessage=""
          handleOnClickYes={() => {
            return this.deleteReceiptList(
              bint_acid,
              bint_tripincomesrno,
              bint_acyear
            );
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };
  handleARDonActionClick_Print = (row) => {
    let bint_acid = row.getValue("bint_acid"),
      bint_acyear = localStorage.getItem("ACY"),
      bint_tripincomesrno = row.getValue("bint_tripincomesrno");
    this.openReceiptPrint(bint_acyear, bint_acid, bint_tripincomesrno);
  };
  // openReceiptPrint = (bint_acyear, bint_acid, bint_tripincomesrno) => {
  //   this.props.notifyProcessing();
  //   let reqData = [
  //     { name: "Op", value: "TripReceiptPrint" },
  //     { name: "bint_acyear", value: bint_acyear },
  //     { name: "bint_acid", value: bint_acid },
  //     { name: "bint_tripincomesrno", value: bint_tripincomesrno },
  //     { name: "bolPrintSingatureStamp", value: 1 },
  //   ];
  //   console.log("reqData", reqData);
  //   var form = document.createElement("form");
  //   form.setAttribute("method", "post");
  //   form.setAttribute("action", apiURL + "incomeentrydetail.php");
  //   form.setAttribute("target", "view");
  //   reqData.forEach((data) => {
  //     var hiddenField = document.createElement("input");
  //     hiddenField.setAttribute("type", "hidden");
  //     hiddenField.setAttribute("name", data.name);
  //     hiddenField.setAttribute("value", data.value);
  //     form.appendChild(hiddenField);
  //     document.body.appendChild(form);
  //   });

  //   window.open("", "view");

  //   form.submit();
  //   this.props.updateProcessing("success", "PDF Open in next Tab.");
  // };

  openReceiptPrint = (bint_acyear, bint_acid, bint_tripincomesrno) => {
    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "TripReceiptPrint" },
      { name: "bint_acyear", value: bint_acyear },
      { name: "bint_acid", value: bint_acid },
      { name: "bint_tripincomesrno", value: bint_tripincomesrno },
      { name: "bolPrintSingatureStamp", value: 1 },
    ];

    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiTransportURL + "tripreceiptdetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "ReceiptList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickAdd: this.handleOnNewEntryClick,
      }),
    });
  };
  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      this.removeKeyboardShortCuts();
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <TripReceiptEntry
              refreshTripReceiptList={this.refreshTripReceiptList}
              dtpFromDate={this.state.formData.dtpFromDate}
              dtpToDate={this.state.formData.dtpToDate}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={this.ShortCut}
        />
      );
      this.setState({ ARD });
    });
  };

  //#endregion handle

  //#region function
  refreshTripReceiptList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  onPaymentModeClick = () => {
    // if (this.validateSales() === true) {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={<PaymentMode />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
    // }
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "bint_tripincomesrno",
        label: "Receipt No",
        value: this.state.searchData.bint_tripincomesrno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dat_date",
        label: "Date",
        value: this.state.searchData.dat_date,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130s",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "LedgerGroup",
        items: this.state.LedgerGroup,
        label: "Ledger Group",
        value: this.state.searchData.vac_groupname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "160",
        maxLength: "100",
        // colID: 'vac_groupname',
      },
      {
        cType: "CtTxt",
        id: "vac_ledgername",
        items: this.state.Ledger,
        label: "Ledger",
        value: this.state.searchData.vac_ledgername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
        // colID:'vac_ledgername',
      },
      {
        cType: "CtTxt",
        id: "dec_amount",
        label: "Amount",
        value: this.state.searchData.dec_amount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      { cType: "Lbl", id: "bint_acid" }
    );
    this.setState({ searchColumns });
  };

  validateReciept = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    if (this.validateReciept()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "TripIncomeList",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
        };
        fetchtripReciept(reqData)
          .then((res) => {
            dataLoadStatus = true;
            dataLoadStatus = true;
            let rows = [],
              rowsCount = rows.length;
            this.props.closeUpdateProcessing();
            if (res.data.TripIncomeList && res.data.TripIncomeList.length > 0) {
              rows = res.data.TripIncomeList;
              rowsCount = rows.length;
            }

            this.setState({
              dataLoadStatus,
              rows,
              rowsCount,
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getInfo.", error);
          });
      });
      document.getElementById("dtpFromDate").focus();
    }
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Receipt",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  onFormLoad = () => {
    // let dtpFromDate = get_30DaysBack_FromCurrentDate(),
    //   dtpToDate = get_YMD_from_SYS(new Date());
    const { fromdate, todate } = getlocalstoragedate("Receipt");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  deleteReceiptList = (bint_acid, bint_tripincomesrno, bint_acyear) => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteTripIncome",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_incomesrno: bint_tripincomesrno,
        dat_fromdate: this.state.formData.dtpFromDate,
        dat_todate: this.state.formData.dtpToDate,
      };
      fetchtripReciept(reqData)
        .then((res) => {
          dataLoadStatus = true;
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState(
              {
                dataLoadStatus,
              },
              () => {
                this.getInfo();
              }
            );
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteReceiptList.", error);
        });
    });
    return true;
  };

  //endregion function
  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Trip Receipt List</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtBtn label="Load" onClick={this.getInfo} />
              </Grid>
            </Grid>
            {/* <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item state display={"none"}>
                <CtBtn label="Payment Mode" onClick={this.onPaymentModeClick} />
              </Grid>
            </Grid> */}
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          {/* <MaterialTable
            rowsdata={rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("Trip Receipt Entry")}
            newBtnName={"New Trip Receipt"}
            newBtnClick={this.handleOnNewEntryClick}
            onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            onPrintAction={this.handleARDonActionClick_Print}
            showColumnFilters={false}
            actionColSize={35}
            hideColIdList={["bint_acid", "dat_date"]}
            density={"compact"}
          /> */}

          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("Trip Receipt Entry")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
              {
                label: "Print",
                onClick: this.handleARDonActionClick_Print,
                icon: "print",
                className: "print-button",
              },
            ]}
            tableButtonAction={[
              {
                label: "New Trip Receipt",
                onClick: this.handleOnNewEntryClick,
                addPluseIcon: true,
              },
            ]}
            showColumnFilters={false}
            actionColSize={90}
            hideColIdList={["bint_acid", "dat_date"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(ReceiptList))));
